import { render, staticRenderFns } from "./epms1020_acc.vue?vue&type=template&id=568284aa&scoped=true"
import script from "./epms1020_acc.vue?vue&type=script&lang=js"
export * from "./epms1020_acc.vue?vue&type=script&lang=js"
import style0 from "./epms1020_acc.vue?vue&type=style&index=0&id=568284aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568284aa",
  null
  
)

export default component.exports